/**
 * 4Endurance UEC 2026 Landing Page
 * Countdown timer + products carousel
 */

(function () {
  'use strict';

  var countdownEl = document.querySelector('[data-uec-countdown]');

  if (countdownEl) {
    var targetDate = new Date(
      countdownEl.getAttribute('data-target')
    ).getTime();

    var daysEl = countdownEl.querySelector('[data-days]');
    var hoursEl = countdownEl.querySelector('[data-hours]');
    var minutesEl = countdownEl.querySelector('[data-minutes]');
    var secondsEl = countdownEl.querySelector('[data-seconds]');

    function pad(number) {
      return number < 10 ? '0' + number : String(number);
    }

    function updateCountdown() {
      var now = Date.now();
      var difference = targetDate - now;

      if (difference <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        return;
      }

      var days = Math.floor(
        difference / (1000 * 60 * 60 * 24)
      );

      var hours = Math.floor(
        (difference / (1000 * 60 * 60)) % 24
      );

      var minutes = Math.floor(
        (difference / (1000 * 60)) % 60
      );

      var seconds = Math.floor(
        (difference / 1000) % 60
      );

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }
})();

(function () {
  'use strict';

  var carouselSelector = '[data-uec-products-carousel]';

  function initCarousel(carousel) {
    if (carousel.dataset.initialized === 'true') {
      return;
    }

    var viewport = carousel.querySelector(
      '[data-carousel-viewport]'
    );

    var previousButton = carousel.querySelector(
      '[data-carousel-previous]'
    );

    var nextButton = carousel.querySelector(
      '[data-carousel-next]'
    );

    if (!viewport || !previousButton || !nextButton) {
      return;
    }

    carousel.dataset.initialized = 'true';

    function getMaximumScroll() {
      return Math.max(
        0,
        viewport.scrollWidth - viewport.clientWidth
      );
    }

    function updateButtons() {
      var maximumScroll = getMaximumScroll();

      previousButton.disabled =
        viewport.scrollLeft <= 5;

      nextButton.disabled =
        maximumScroll <= 5 ||
        viewport.scrollLeft >= maximumScroll - 5;
    }

    previousButton.addEventListener('click', function () {
      viewport.scrollBy({
        left: -viewport.clientWidth,
        behavior: 'smooth'
      });
    });

    nextButton.addEventListener('click', function () {
      viewport.scrollBy({
        left: viewport.clientWidth,
        behavior: 'smooth'
      });
    });

    viewport.addEventListener(
      'scroll',
      updateButtons,
      { passive: true }
    );

    window.addEventListener('resize', updateButtons);

    requestAnimationFrame(updateButtons);
  }

  function initAllCarousels(container) {
    container = container || document;

    if (
      container.matches &&
      container.matches(carouselSelector)
    ) {
      initCarousel(container);
    }

    var carousels =
      container.querySelectorAll(carouselSelector);

    carousels.forEach(function (carousel) {
      initCarousel(carousel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAllCarousels(document);
      }
    );
  } else {
    initAllCarousels(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAllCarousels(event.target);
    }
  );
})();